import React from 'react';

import EmailRounded from '@material-ui/icons/EmailRounded';
import wpStyles from '../../wordpressStyles';


const Footer = ({ ...props }) => {
    const email = props.data.event.support_email
        ? `mailto:${props.data.event.support_email}?subject=${props.data.event.support_subject}`
        : '';
    return (
        <div className="min-h-short">
            {email != '' && (
                <a target="_blank" href={email}>
                    <div className="hidden lg:flex fixed w-16 h-16 right-0 bottom-0 mb-4 mr-4 shadow-lg items-center justify-center rounded-full" style={wpStyles.backgroundColor1}>
                        <div className="flex w-full h-full items-center justify-center text-white text-5xl">
                            <EmailRounded />
                        </div>
                    </div>
                </a>
            )}
            
        </div>
    );
};
export default Footer;
